import { CLOSE_MODAL } from "./ActionConstant";
import { TOGGLE_MODAL } from "./ActionConstant";
import { OPEN_MODAL } from "./ActionConstant";
import {
  HIDE_USER_OTP_MODAL,
  SHOW_USER_OTP_MODAL,
  TOGGLE_USER_OTP_MODAL,
  HIDE_USER_UNVERIFIED_MODAL,
  SHOW_USER_UNVERIFIED_MODAL,
  TOGGLE_USER_UNVERIFIED_MODAL,
  HIDE_LIVE_STREAMING_PAYMENT_DIALOG,
  SHOW_LIVE_STREAMING_PAYMENT_DIALOG,
  HIDE_PERFORMER_PROFILE_PICTURE_MISSING_MODAL,
  SHOW_PERFORMER_PROFILE_PICTURE_MISSING_MODAL,
  TOGGLE_PERFORMER_PROFILE_PICTURE_MISSING_MODAL,
  HIDE_CARD_ADDRESS_MISMATCH_MODAL, 
  SHOW_CARD_ADDRESS_MISMATCH_MODAL, 
  TOGGLE_CARD_ADDRESS_MISMATCH_MODAL,
  HIDE_CARD_MANUAL_REVIEW_REQUIRED_MODAL,
  SHOW_CARD_MANUAL_REVIEW_REQUIRED_MODAL,
  TOGGLE_CARD_MANUAL_REVIEW_REQUIRED_MODAL
} from "./ActionConstant";

export function hideUnverifiedPerformerModal(data) {
  return {
    type: HIDE_USER_UNVERIFIED_MODAL,
    data,
  };
}

export function showUnverifiedPerformerModal(data) {
  return {
    type: SHOW_USER_UNVERIFIED_MODAL,
    data,
  };
}

export function toggleUnverifiedPerformerModal(data) {
  return {
    type: TOGGLE_USER_UNVERIFIED_MODAL,
    data,
  };
}

export function hidePerformerMissingProfilePictureModal(data) {
  return {
    type: HIDE_PERFORMER_PROFILE_PICTURE_MISSING_MODAL,
    data,
  };
}

export function showPerformerMissingProfilePictureModal(data) {
  return {
    type: SHOW_PERFORMER_PROFILE_PICTURE_MISSING_MODAL,
    data,
  };
}

export function togglePerformerMissingProfilePictureModal(data) {
  return {
    type: TOGGLE_PERFORMER_PROFILE_PICTURE_MISSING_MODAL,
    data,
  };
}

export function hideUserOTPModal(data) {
  return {
    type: HIDE_USER_OTP_MODAL,
    data,
  };
}

export function showUserOTPModal(data) {
  return {
    type: SHOW_USER_OTP_MODAL,
    data,
  };
}

export function toggleUserOTPModal(data) {
  return {
    type: TOGGLE_USER_OTP_MODAL,
    data,
  };
}

export function openModal(modalType, modalData) {
  return {
    type: OPEN_MODAL,
    data: {
      type: modalType,
      data: modalData,
    },
  };
}

export function closeModal() {
  return {
    type: CLOSE_MODAL,
  };
}

export function toggleModal(modalType, modalData) {
  return {
    type: TOGGLE_MODAL,
    data: {
      type: modalType,
      data: modalData,
    },
  };
}

export function showLiveStreamingPaymentModal(data) {
  return {
    type: SHOW_LIVE_STREAMING_PAYMENT_DIALOG,
    data
  };
}

export function hideLiveStreamingPaymentModal(data) {
  return {
    type: HIDE_LIVE_STREAMING_PAYMENT_DIALOG,
    data
  };
}

export function hideCardAddressMismatchModal(data) {
  return {
    type: HIDE_CARD_ADDRESS_MISMATCH_MODAL,
    data,
  };
}

export function showCardAddressMismatchModal(data) {
  return {
    type: SHOW_CARD_ADDRESS_MISMATCH_MODAL,
    data,
  };
}

export function toggleCardAddressMismatchModal(data) {
  return {
    type: TOGGLE_CARD_ADDRESS_MISMATCH_MODAL,
    data,
  };
}

export function hideCardManualReviewRequiredModal() {
  return {
    type: HIDE_CARD_MANUAL_REVIEW_REQUIRED_MODAL,
  };
}

export function showCardManualReviewRequiredModal() {
  return {
    type: SHOW_CARD_MANUAL_REVIEW_REQUIRED_MODAL,
  };
}

export function toggleCardManualReviewRequiredModal() {
  return {
    type: TOGGLE_CARD_MANUAL_REVIEW_REQUIRED_MODAL,
  };
}
